import { firestore } from "firebase";
import router from "../../router";

export default {
  namespaced: true,
  state: {
    topic: {},
    topics: [],
    user: "",
    temp: ""
  },
  actions: {
    saveTopic(context, topico) {
      const projectID = router.currentRoute.params.project_id;
      // eslint-disable-next-line no-console
      console.log(topico);
      const storageRefTopic = firestore()
        .collection(`Project`)
        .doc(projectID);
      storageRefTopic
        .collection(`Topic`)
        .add(topico)
        // eslint-disable-next-line no-console
        .then(() => console.log("Topico Guardado con exito"))
        .catch(() => {
          // eslint-disable-next-line no-console
          console.log("No se guardo el topico");
        });
    },
    updateTopic({ commit }, payload) {
      const projectID = router.currentRoute.params.project_id;
      const topicID = router.currentRoute.params.topic_id;
      firestore()
        .collection(`Project`)
        .doc(projectID)
        .collection(`Topic`)
        .doc(topicID)
        .update(payload)
        .then(() => {
          // eslint-disable-next-line no-console
          console.log("El topico fue actualizado");
          commit('UPDATE_TOPIC',"Completado")
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.log("Ocurrió un error: ", err);
        });
    },
    listTopics({ commit }) {
      const projectID = router.currentRoute.params.project_id;
      const topicsRef = firestore()
        .collection(`Project`)
        .doc(projectID)
        .collection(`Topic`);
      topicsRef
        .get()
        .then(snapshot => {
          const array = [];
          snapshot.forEach(doc => {
            const data = doc.data();
            data.id = doc.id;
            array.unshift(data);
          });
          commit(`INSERT_LIST_TOPICS`, array);
          // eslint-disable-next-line no-console
          console.log("Los topicos fueron cargados");
        })
        .catch(() => {
          // eslint-disable-next-line no-console
          console.log("Los topicos no fueron cargados");
        });
    },
    onceTopic({ state, commit }) {
      const topicID = router.currentRoute.params.topic_id;
      const projectID = router.currentRoute.params.project_id;
      const topicsRefDatabase = firestore()
        .collection(`Project`)
        .doc(projectID)
        .collection(`Topic`)
        .doc(topicID);
      topicsRefDatabase.get().then(doc => {
        const information = doc.data();
        information.id = state.topicID;
        commit(`INSERT_TOPIC`, information);
        // eslint-disable-next-line no-console
        console.log("Topico Cargado");
      });
    }
  },
  mutations: {
    INSERT_TOPIC(state, topic) {
      state.topic = topic;
    },
    INSERT_LIST_TOPICS: (state, topics) => {
      // eslint-disable-next-line no-console
      state.topics = topics;
    },
    UPDATE_TOPIC: (state, topic) => {
      state.temp = topic;
    },
    insertUser: (state, user) => {
      state.user = user;
    },
    deleteTopic: (state, topicID) => {
      const projectID = router.currentRoute.params.project_id;
      // eslint-disable-next-line no-console
      console.log(topicID);
      const databaseRefTopic = firestore().ref(
        `project/${projectID}/topics/${topicID}`
      );
      databaseRefTopic.remove();
    }
  },
  getters: {
    getTopic: state => {
      return state.topic;
    },
    getListTopic: state => {
      return state.topics;
    }
  }
};
